import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import VivoCreators from './components/VivoCreators';
import Services from './components/Services';
import ExperienceVivo from './components/ExperienceVivo';
import ExperiencePractice from './components/ExperiencePractice';
import Commissions from './components/Commissions';
import Cases from './components/Cases';
import Social from './components/Social';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import LinksPage from './components/LinksPage';
import SobrePage from './components/SobrePage';
import { applyPageMeta } from './utils/seo';
import './styles/main.css';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    applyPageMeta({
      title: 'Tiago Cardoso | Arquiteto de Soluções Digitais | Vivo Creator',
      description: 'Arquiteto de soluções digitais, Vivo Creator e consultor tech. Arquitetura de soluções, conectividade, automação e conteúdo tech.',
      canonical: 'https://ticardoso.com.br/'
    });
  }, []);

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <VivoCreators />
        <Services />
        <ExperienceVivo />
        <ExperiencePractice />
        <Commissions />
        <Cases />
        <Social />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/links" element={<LinksPage />} />
            <Route path="/sobre" element={<SobrePage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
